export default function Navbar() {
  return (
    <nav className="fixed top-0 w-full z-50 bg-black/70 backdrop-blur border-b border-white/10">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
        <h1 className="text-xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
          Ebin Benny
        </h1>

        <div className="space-x-6 text-sm">
          <a href="#home" className="hover:text-green-400">Home</a>
          <a href="#about" className="hover:text-green-400">About</a>
          <a href="#resume" className="hover:text-green-400">Resume</a>
          <a href="#portfolio" className="hover:text-green-400">Work</a>
          <a href="#contact" className="hover:text-green-400 cta">Contact</a>
        </div>
      </div>
    </nav>
  );
}
